import { useDispatch } from 'react-redux';
import { useAsyncAction } from 'Hooks/Common';
import { TeamMember } from 'Interfaces/Team';
import { $actions } from 'Store/ducks';

export default () => {
  const dispatch = useDispatch();

  return useAsyncAction((teamMembersIds: TeamMember['id'][]) =>
    $actions.team.deleteTeamMembers(dispatch, { teamMembersIds }),
  );
};
